import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust the path based on your project structure

const UpdateCardGroup = () => {
  const [cardGroup, setCardGroup] = useState({
    grpname: '',
    grpsymbol: '',
    gamename: '',
    gamecategory: '',
    gamechallenges: ''
  });

  const navigate = useNavigate();
  const { cardgrpid } = useParams();

  useEffect(() => {
    fetchCardGroupData();
  }, []);

  const fetchCardGroupData = () => {
    axios({
      url: API.GET_CARDGROUP_BYID(cardgrpid), 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setCardGroup(res.data[0]); 
      })
      .catch((err) => {
        alert('Error fetching card group data: ' + err);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCardGroup({ ...cardGroup, [name]: value });
  };

  const updateCardGroup = (e) => {
    e.preventDefault();
    axios.put(API.PUT_CARDGROUP_API(cardgrpid), cardGroup, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then((res) => {
        alert('Card group updated successfully');
        navigate('/cardgrouptable');
    })
    .catch((err) => {
        console.error('Error updating card group:', err);
        alert('Error updating card group: ' + err.message);
    });
    
  };

  const goBack = () => {
    navigate('/cardgrouptable');
  };

  return (
    <div className='bg-[#B5B5B5] h-auto pb-20 pt-10'>
      <div className='max-w-4xl mx-auto pt-10'>
        <form onSubmit={updateCardGroup} className='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4'>
          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Group Name</label>
            <input
              type='text'
              name='grpname'
              value={cardGroup.grpname}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Group Symbol</label>
            <input
              type='text'
              name='grpsymbol'
              value={cardGroup.grpsymbol}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Name</label>
            <input
              type='text'
              name='gamename'
              value={cardGroup.gamename}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Category</label>
            <input
              type='text'
              name='gamecategory'
              value={cardGroup.gamecategory}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
            />
          </div>

          <div className='mb-4'>
            <label className='block text-gray-700 text-sm font-bold mb-2'>Game Challenges</label>
            <textarea
              name='gamechallenges'
              value={cardGroup.gamechallenges}
              onChange={handleInputChange}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
              rows={4}
            />
          </div>

          <div className='flex items-center justify-between'>
            <button
              type='submit'
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Update
            </button>
            <button
              type='button'
              onClick={goBack}
              className='bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCardGroup;
